import { useMemo, useState } from 'react';

import { useSimpleModalState } from 'approot/shared/modal/modal.hooks';
import SubActivityView from '../../sub-activity/sub-activity-view';
import { computePaddingTop } from '../../shared/component-height/component-dimension.utils';
import { ComponentOverlayWrapper } from '../../shared/component-overlay/component-overlay.style';
import ComponentOverlaySample from '../../shared/component-overlay/component-overlay-sample';
import { ViewProps } from '../draw.constants';
import DrawCanvasPreview from '../draw-canvas-preview';
import DrawViewSampleAnswer from './draw-view-sample-answer';
import * as Styled from '../draw-view.style';
import { SampleProps } from '../../sample/activity-sample.constants';
import { useDrawLanguage } from '../canvas/use-draw-language';

const DrawViewSample = (
  props: ViewProps &
    SampleProps & {
      onOpenDrawCanvas: () => void;
    }
) => {
  const { id, properties, subActivityProperties, onOpenDrawCanvas } = props;
  const [previewRef, setPreviewRef] = useState<HTMLDivElement | null>(null);
  const language = useDrawLanguage();

  const { isVisible, openModal, closeModal } = useSimpleModalState();

  const paddingTop = useMemo(
    () => computePaddingTop(properties.dimensionData),
    [properties.dimensionData]
  );

  return (
    <SubActivityView subActivityDetails={subActivityProperties}>
      <Styled.DrawViewTeacher>
        <ComponentOverlayWrapper>
          <Styled.DrawCanvas
            data-selector="drawing-container"
            style={{
              paddingTop: `${paddingTop}%`,
            }}
          >
            <Styled.DrawViewPreview
              ref={setPreviewRef}
              role="image"
              aria-label={properties.altText || ''}
            >
              {previewRef && (
                <DrawCanvasPreview
                  id={id}
                  key={id}
                  dimensionsData={properties.dimensionData}
                  imageUrl={properties.image?.original}
                  containerEl={previewRef}
                  questionData={properties.draw}
                  language={language}
                />
              )}
            </Styled.DrawViewPreview>
          </Styled.DrawCanvas>
          <ComponentOverlaySample
            onClick={() => {
              openModal();
              onOpenDrawCanvas();
            }}
          />
        </ComponentOverlayWrapper>

        {isVisible && (
          <DrawViewSampleAnswer
            {...props}
            language={language}
            closeModal={closeModal}
          />
        )}
      </Styled.DrawViewTeacher>
    </SubActivityView>
  );
};

export default DrawViewSample;
